<div class="page-wrapper gallery-wrapper" [ngClass]="scrollingClass"
     infinite-scroll
     [infiniteScrollDistance]="3"
     [infiniteScrollThrottle]="1000"
     [scrollWindow]="false"
     (scrolled)="onImagesScroll()">
    <div class="header">
        <app-header
                [headerText]="'CMS.MEDIA.TILE_TITLE' | translate"
                [headerParagraph]="'CMS.MEDIA.DESCRIPTION' | translate"
                [backButtonDisplayed]="true"
                [backButtonLabel]="'GENERAL.BACK' | translate"
                [leaveButton]="true"
                [leaveButtonLabel]="'GENERAL.LOGOUT' | translate"
                (buttonEvent)="backButtonAction()"
                (leaveIndication)="onLogOut()">
        </app-header>
    </div>

    <div class="action-toolbar">
        <app-button [cssClasses]="'btn small outlined__gray-07'"
                    [customIcon]="'copy'"
                    [disabled]="!oneFileSelected"
                    (buttonClicked)="onCopyCode()">
            {{'GENERAL.GET_CODE' | translate}}
        </app-button>
        <app-button [cssClasses]="'btn small outlined__gray-07'"
                    [icon]="'edit'"
                    [disabled]="true">
            {{'GENERAL.RENAME' | translate}}
        </app-button>
        <app-button [cssClasses]="'btn small outlined__gray-07'"
                    [icon]="'delete'"
                    [disabled]="markedImages.length < 1"
                    (buttonClicked)="onDeleteFile()">
            {{'GENERAL.DELETE' | translate}}
        </app-button>
    </div>

    <div role="main" class="content gallery">
        <div class="gallery__button" [tabIndex]="0">
            <app-file-upload
                    [uploadFinished]="noOfFilesToUpload === 0"
                    (emitUploadedImage)="onImagesUploaded($event)"
                    (emitNumberOfFilesToUpload)="setNumberOfFileToUpload($event)">
            </app-file-upload>
        </div>
        <div *ngFor="let image of imagesDetails" class="gallery__image" [tabIndex]="0">
            <app-image-card
                    [showCheckbox]="cardChecked"
                    [image]="image"
                    (checkCardEvent)="onCheckCard($event)"
                    (imageMarkedEvent)="onImageMarked($event)"
                    (imageClickedEvent)="onImageClicked($event)">
            </app-image-card>
        </div>
    </div>

    <app-notification></app-notification>
</div>